import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@leagueplatform/auth-utils";
import { LoadingIndicator } from "@leagueplatform/web-common-components";
import {
  ALLOWED_UNAUTHENTICATED_ROUTES,
  APP_MANAGED_ROUTES,
} from "common/app-managed-routes";
import { PrivateRoutesContainer } from "components/private-routes-container/private-routes-container";

export const AuthSessionContainer = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const doesNotRequireAuthentication = ALLOWED_UNAUTHENTICATED_ROUTES.some(
    (path) => location.pathname === path
  );

  // Don't let the SDK auto-redirect to Auth0. We want unauthenticated users
  // landing on the pre-login page instead of going straight to the IdP.
  const { isAuthenticated, error } = useAuth({
    redirectToLogInWhenSignedOut: false,
  });

  useEffect(() => {
    if (!error) return;
    const params = new URLSearchParams({ error: error.type });
    if (error.description)
      params.append("error_description", error.description);
    navigate(`/?${params}`);
  }, [error, navigate]);

  if (isAuthenticated === undefined) return <LoadingIndicator />;

  if (isAuthenticated === false) {
    if (doesNotRequireAuthentication) return children;
    return <Navigate to={APP_MANAGED_ROUTES.LANDING_PAGE} replace />;
  }

  return <PrivateRoutesContainer>{children}</PrivateRoutesContainer>;
};
